<template>
    <svg
        id="Calque_2"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 108.06 114.09"
        fill="none"
        height="31"
        width="45"
    >
        <g>
            <rect class="cls-1" x="41.79" y="8.02" width="22.84" height="9.23" rx="3.94" ry="3.94"/>
            <rect class="cls-1" x="37.44" y="46.11" width="31.45" height="8.85" rx="3.94" ry="3.94"/>
            <rect class="cls-1" x="35.4" y="17.25" width="35.61" height="9.62" rx="3.94" ry="3.94"/>
            <path class="cls-1" d="M35.04,26.87h13.67v9.62h-13.67c-2.17,0-3.94-1.76-3.94-3.94v-1.75c0-2.17,1.76-3.94,3.94-3.94Z"/>
            <path class="cls-1" d="M61.46,26.87h13.76v9.62h-13.76c-2.17,0-3.94-1.76-3.94-3.94v-1.75c0-2.17,1.76-3.94,3.94-3.94Z" transform="translate(132.74 63.37) rotate(180)"/>
            <path class="cls-1" d="M61.46,36.49h11.53v9.62h-11.53c-2.17,0-3.94-1.76-3.94-3.94v-1.75c0-2.17,1.76-3.94,3.94-3.94Z" transform="translate(130.52 82.6) rotate(-180)"/>
            <rect class="cls-1" x="43.5" y="32.09" width="19.24" height="8.81" rx="3.94" ry="3.94" transform="translate(16.63 89.61) rotate(-90)"/>
            <path class="cls-1" d="M37.08,36.49h11.64v9.62h-11.64c-2.17,0-3.94-1.76-3.94-3.94v-1.75c0-2.17,1.76-3.94,3.94-3.94Z"/>
        </g>
        <g>
            <rect class="cls-1" x="15.08" y="61.39" width="22.84" height="9.23" rx="3.94" ry="3.94"/>
            <rect class="cls-1" x="10.73" y="99.48" width="31.45" height="8.85" rx="3.94" ry="3.94"/>
            <rect class="cls-1" x="8.7" y="70.62" width="35.61" height="9.62" rx="3.94" ry="3.94"/>
            <path class="cls-1" d="M8.33,80.24h13.67v9.62h-13.67c-2.17,0-3.94-1.76-3.94-3.94v-1.75c0-2.17,1.76-3.94,3.94-3.94Z"/>
            <path class="cls-1" d="M34.75,80.24h13.76v9.62h-13.76c-2.17,0-3.94-1.76-3.94-3.94v-1.75c0-2.17,1.76-3.94,3.94-3.94Z" transform="translate(79.33 170.1) rotate(180)"/>
            <path class="cls-1" d="M34.75,89.86h11.53v9.62h-11.53c-2.17,0-3.94-1.76-3.94-3.94v-1.75c0-2.17,1.76-3.94,3.94-3.94Z" transform="translate(77.1 189.34) rotate(-180)"/>
            <rect class="cls-1" x="16.79" y="85.45" width="19.24" height="8.81" rx="3.94" ry="3.94" transform="translate(-63.45 116.27) rotate(-90)"/>
            <path class="cls-1" d="M10.37,89.86h11.64v9.62h-11.64c-2.17,0-3.94-1.76-3.94-3.94v-1.75c0-2.17,1.76-3.94,3.94-3.94Z"/>
        </g>
        <g>
            <rect class="cls-1" x="68.12" y="61.39" width="22.84" height="9.23" rx="3.94" ry="3.94"/>
            <rect class="cls-1" x="63.77" y="99.48" width="31.45" height="8.85" rx="3.94" ry="3.94"/>
            <rect class="cls-1" x="61.74" y="70.62" width="35.61" height="9.62" rx="3.94" ry="3.94"/>
            <path class="cls-1" d="M61.37,80.24h13.67v9.62h-13.67c-2.17,0-3.94-1.76-3.94-3.94v-1.75c0-2.17,1.76-3.94,3.94-3.94Z"/>
            <path class="cls-1" d="M87.79,80.24h13.76v9.62h-13.76c-2.17,0-3.94-1.76-3.94-3.94v-1.75c0-2.17,1.76-3.94,3.4-3.94Z" transform="translate(185.41 170.1) rotate(180)"/>
            <path class="cls-1" d="M87.79,89.86h11.53v9.62h-11.53c-2.17,0-3.94-1.76-3.94-3.94v-1.75c0-2.17,1.76-3.94,3.94-3.94Z" transform="translate(183.18 189.34) rotate(-180)"/>
            <rect class="cls-1" x="69.83" y="85.45" width="19.24" height="8.81" rx="3.94" ry="3.94" transform="translate(-10.41 169.31) rotate(-90)"/>
            <path class="cls-1" d="M63.41,89.86h11.64v9.62h-11.64c-2.17,0-3.94-1.76-3.94-3.94v-1.75c0-2.17,1.76-3.94,3.94-3.94Z"/>
        </g>
    </svg>
</template>

<script>
export default {
    name: 'CustomSvg',
}
</script>

<style scoped>
.cls-1 {
    fill: none;
    stroke: #fab42e;
    stroke-miterlimit: 10;
    stroke-width: 4px;
}
</style>